import { CLAccount } from '../../shares-ledger/client/account';
import { DLCompany } from './company';

export type DLAuthorizationType = 'FULL';

interface CreateDLAuthorizationInput {
  account: string
  company: string
  type: DLAuthorizationType
}

export class DLAuthorization {
  id: string
  account: CLAccount
  company: DLCompany
  type: DLAuthorizationType
  createdAt: number
  updatedAt: number

  constructor(data: any = {}) {
    Object.assign(this, data);

    if (this.account) {
      this.account = new CLAccount(this.account);
    }

    if (this.company) {
      this.company = new DLCompany(this.company);
    }
  }

  get valid():boolean {
    if(!this.account) {
      return false;
    }

    if(!this.company) {
      return false;
    }

    if(!this.type) {
      return false;
    }

    return true;
  }

  toCreateDLAuthorizationInput(): CreateDLAuthorizationInput {
    return {
      account: this.account.id,
      company: this.company.id,
      type: this.type,
    };
  }
}
